import React from "react";
import CourseCard from "./courseCard";
const courses = [
  {
    id: 1,
    title: "Learn JavaScript",
    subheading: "Master the fundamentals of JavaScript",
    description:
      "This course will teach you the core concepts of JavaScript, including variables, data types, control flow, functions, and more.",
    rating: 4.8,
    reviews: 1200,
    instructor: "John Doe",
    price: 99,
    image: "javascript.jpg",
    level: "Beginner",
    category: "Programming",
  },
  {
    id: 5,
    title: "Learn JavaScript",
    subheading: "Master the fundamentals of JavaScript",
    description:
      "This course will teach you the core concepts of JavaScript, including variables, data types, control flow, functions, and more.",
    rating: 4.8,
    reviews: 1200,
    instructor: "John Doe",
    price: 99,
    image: "javascript.jpg",
    level: "Beginner",
    category: "Programming",
  },
  {
    id: 6,
    title: "React for Beginners",
    subheading: "Build amazing user interfaces with React",
    description:
      "Learn how to build dynamic and interactive user interfaces using React, a popular JavaScript library.",
    rating: 4.7,
    reviews: 850,
    instructor: "Jane Smith",
    price: 149,
    image: "react.jpg",
    level: "Beginner",
    category: "Frontend Development",
  },
  {
    id: 7,
    title: "Data Science with Python",
    subheading: "Unlock the power of data with Python",
    description:
      "This course will cover the essential libraries for data science in Python, including NumPy, Pandas, and Matplotlib.",
    rating: 4.9,
    reviews: 1500,
    instructor: "David Lee",
    price: 199,
    image: "python.jpg",
    level: "Intermediate",
    category: "Data Science",
  },
  {
    id: 8,
    title: "Introduction to Machine Learning",
    subheading: "Learn the fundamentals of machine learning algorithms",
    description:
      "Explore various machine learning algorithms, including supervised, unsupervised, and reinforcement learning.",
    rating: 4.6,
    reviews: 900,
    instructor: "Sarah Jones",
    price: 249,
    image: "machine_learning.jpg",
    level: "Intermediate",
    category: "AI & Machine Learning",
  },
  {
    id: 7,
    title: "Data Science with Python",
    subheading: "Unlock the power of data with Python",
    description:
      "This course will cover the essential libraries for data science in Python, including NumPy, Pandas, and Matplotlib.",
    rating: 4.9,
    reviews: 1500,
    instructor: "David Lee",
    price: 199,
    image: "python.jpg",
    level: "Intermediate",
    category: "Data Science",
  },
  {
    id: 8,
    title: "Introduction to Machine Learning",
    subheading: "Learn the fundamentals of machine learning algorithms",
    description:
      "Explore various machine learning algorithms, including supervised, unsupervised, and reinforcement learning.",
    rating: 4.6,
    reviews: 900,
    instructor: "Sarah Jones",
    price: 249,
    image: "machine_learning.jpg",
    level: "Intermediate",
    category: "AI & Machine Learning",
  },
  {
    id: 7,
    title: "Data Science with Python",
    subheading: "Unlock the power of data with Python",
    description:
      "This course will cover the essential libraries for data science in Python, including NumPy, Pandas, and Matplotlib.",
    rating: 4.9,
    reviews: 1500,
    instructor: "David Lee",
    price: 199,
    image: "python.jpg",
    level: "Intermediate",
    category: "Data Science",
  },
  {
    id: 8,
    title: "Introduction to Machine Learning",
    subheading: "Learn the fundamentals of machine learning algorithms",
    description:
      "Explore various machine learning algorithms, including supervised, unsupervised, and reinforcement learning.",
    rating: 4.6,
    reviews: 900,
    instructor: "Sarah Jones",
    price: 249,
    image: "machine_learning.jpg",
    level: "Intermediate",
    category: "AI & Machine Learning",
  },
  // Add more courses here...
];

const Recommended = () => {
  return (
    <div className="w-full mx-auto p-6 space-y-6 border-blue-500 border p-2">
      <div className="space-y-4">
        <h2 className="text-2xl font-bold text-indigo-900">
          Recommended For You
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {courses.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default Recommended;
